import React from 'react';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { red } from '@mui/material/colors';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box,  useTheme } from '@mui/system';
import { Divider } from '@mui/material';
import Chip from '@mui/material/Chip';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ListAltIcon from '@mui/icons-material/ListAlt';

import PopupSocialShare from '../Popup/PopupSocialShare';
import notifications from '../../utils/notifications';
import { CATEGORIES_URL } from '../../config/urls';

const {REACT_APP_BASE_BACKEND_URL} = process.env;
const TOGGLE_FAVORITE_API_URL = `${REACT_APP_BASE_BACKEND_URL}/api/toggle-favorite`

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));
const getTags = (tags) => {
  const tagList = tags.split(',');
  return tagList;
}
const CourseItems = ({course, index, authenticated, setOpenLoginPopup}) => {
  const {
   id, 
   course_name, 
   author, 
   publisher,
   thumbnail_url, 
   url, 
   description_array, 
   published_date, 
   tags, 
   is_favorite,
   number_of_lectures,
   duration,
  } = course;

  const [openSocialShare, setOpenSocialShare] = React.useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const theme = useTheme();
  const token = window.localStorage.getItem('jwt');


  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const [isFavorite, setIsFavorite] = React.useState(is_favorite);
  
  React.useEffect(()=>{
    setIsFavorite(is_favorite);
  },[is_favorite])

  const toggleFavorite = () =>{
    fetch(TOGGLE_FAVORITE_API_URL, {
      method: 'POST',
      credentials: 'include',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `${token && `jwt ${token}`}`
    },
      body: JSON.stringify({'course_id': id})
    }).then(res => {
      if (res.ok) {
        setIsFavorite(!isFavorite);
        return;
      }
      else if (res.status === 401){
        console.log('not authorized')
      }
      else return res.json().then(msg => {throw new Error(msg)})
    }).catch(error =>{
      notifications();
      console.error(error);
    })
  }
  const getDuration = (duration)=>{
    let [hours, mins, sec] = duration.split(':');
    if(hours.length > 2) {
      let [days, hour] = hours.split(' ');
      hours= parseInt(days)*24 + parseInt(hour);
    }
    else hours = parseInt(hours);
    mins =  parseInt(mins);
    
    const hoursDisplay = hours > 0 ? (hours + 'h') : "";
    const minsDisplay = mins > 0 ? (mins + 'm') : "";

    return hoursDisplay + ' ' + minsDisplay;

  }
  
  return (
    <Box 
      display={'block'}
      data-aos={'fade-up'}
      data-aos-delay={index * 100}
    >

    <Box
      display={'block'}
      width={1}
      
      sx={{
      textDecoration: 'none',
      transition: 'all .2s ease-in-out',
      '&:hover': {
          transform: `translateY(-${theme.spacing(1 / 2)})`,
              },
      }}
    >
      <Box
        component={Card}
        width={1}
        height={1}
        boxShadow={4}
        display={'flex'}
        flexDirection={'column'}
        sx={{ backgroundImage: 'none',}}
      >

        {/*--- Course Thumbnail ---*/}
        <Box 
          component = 'a'
          href={url}
          target={'_blank'}
        >
          <CardMedia
            component="img"
            image={thumbnail_url}
            title={course_name}
            sx={{
              position: 'relative',
              objectFit: 'contain',
            }}
          />
        </Box>

        

        {/*--- Course header: course name, author ---*/}
        <Box padding={0} component={CardContent} position={'relative'}>
          <CardHeader
              avatar={
                <Avatar alt={author.name} src={author.avatar} />
              }
              title={course_name}
              subheader={publisher? `${author.name} | ${publisher}` : author.name}
          />
          
        </Box>
          
        {/* --- Course description --- */}
        <Box>
          <Collapse in={expanded} timeout="auto" >
            <CardContent>
              {description_array.map((item, index) => (
                <Typography key={index}>
                  &nbsp; {item}
                </Typography>
              ))}
              <Typography 
              fontStyle= {'italic'}
              fontSize={'0.85rem'}
              fontWeight={'light'}
              textAlign={'right'}
              style={{
                filter: 'brightness(50%)'
              }}
              >
                Updated on: {published_date}
              </Typography>
            </CardContent >

        {/*--- Course Tags ---*/}
          <Box sx={{margin: '0 15px'}}>
            {getTags(tags).map((item) => (
              <Chip
                key={item}
                label={item}
                component="a"
                href={`${CATEGORIES_URL}/?t=${item}`}
                clickable
                size={'small'}
                sx={{ 
                  margin: '5px',
                  fontSize: '0.7rem',
                  textTransform: 'capitalize',
                }}
              />
            ))}
          </Box>
          </Collapse>
        </Box>

        {/* --- Course sub-content: duration, number of videos --- */}
        {(duration && number_of_lectures) && 
        <Box display={'flex'} justifyContent={'space-between'}>
          <Typography 
            display={'flex'} 
            justifyContent={'center'}
            alignItems={'center'}
            sx={{
              margin: '10px 20px',
              fontSize: '0.9rem',
              opacity: '0.8',
            }}
          >
            <AccessTimeIcon 
              sx={{
                marginRight: '5px',
                color : red[300],
                fontSize: '1.4rem'
              }}
            />  {getDuration(duration)}
          </Typography>
          <Typography 
            display={'flex'} 
            justifyContent={'center'}
            alignItems={'center'}
            sx={{
              margin: '5px 20px', 
              fontSize: '0.9rem',
              opacity: '0.8',
            }}
          >
            <ListAltIcon 
              sx={{
                marginRight: '5px',
                fontSize: '1.4rem'
              }} color='secondary'
            /> {number_of_lectures
              ? (`${number_of_lectures} ${number_of_lectures === 1 ? 'lecture':  'lectures'}`)
              : null}
          </Typography>
        </Box>
        }


        {/* --- Footer --- */}
        <Box padding={0 } display={'flex'} flexDirection={'column'}>
          <Box >
            <Divider />
          </Box>

          <Box
            display={'flex'}
            justifyContent={'space-between'}
            alignItems={'center'}
          >
            <Box display={'flex'} alignItems={'center'}>
              <CardActions disableSpacing>
                <Box >
                  {authenticated
                    ?(  
                      <IconButton onClick={toggleFavorite} aria-label="add to favorites" >
                        <FavoriteIcon sx={{color: isFavorite ? red[400] : 'inherit'}}/> 
                      </IconButton>
                    ): (
                      <IconButton onClick={()=>setOpenLoginPopup(true)} aria-label="add to favorites" >
                        <FavoriteIcon/>
                      </IconButton>
                    )
                  }
                  <IconButton onClick={()=> setOpenSocialShare(true)} aria-label="share">
                    <ShareIcon />
                  </IconButton>
                </Box>
              </CardActions>

            </Box>

            <Box>
              <CardActions padding={0}>
                <ExpandMore
                    expand={expanded}
                    onClick={handleExpandClick}
                    aria-expanded={expanded}
                    aria-label="show more"
                    >
                    <ExpandMoreIcon />
                </ExpandMore>
              </CardActions>
            </Box>
          </Box>
        </Box>
      </Box>
      
      <PopupSocialShare 
        open={openSocialShare} 
        onClose={() => setOpenSocialShare(false)} 
        courseURL = {url} 
        courseName={course_name}
      />
      {/* <PopupLoginRequired
        open={openLoginPopup} 
        onClose={() => setOpenLoginPopup(false)} 
      /> */}
    </Box>
    </Box>

  )
}
  

export default CourseItems;
